<script lang="ts" setup>
import { VAppBar, VToolbar, VAppBarTitle, VToolbarTitle } from 'vuetify/components'

const props = withDefaults(
  defineProps<{
    title?: string
    app?: boolean
    dismissible?: boolean
    /**
     * @deprecated Use `dismissible` instead
     */
    isCloseable?: boolean
    loading?: boolean
    bordered?: boolean
  }>(),
  {
    bordered: true,
  }
)

const emit = defineEmits<{
  close: []
}>()

const isDismissible = computed(() => {
  return props.dismissible || props.isCloseable
})

const invitingBusinessId = inject(INVITING_BUSINESS_ID, ref(''))

const { data: publicBusinessInfo } = usePublicInformation(invitingBusinessId, {
  watch: [invitingBusinessId],
})

const srBrandingLogoUrl = computed(() => publicBusinessInfo.value?.companyBranding?.logo?.url ?? '')

const mainComponent = computed(() => {
  return props.app ? VAppBar : VToolbar
})

const titleComponent = computed(() => {
  return props.app ? VAppBarTitle : VToolbarTitle
})
</script>

<template>
  <component
    :is="mainComponent"
    class="toolbar"
    :class="{ 'toolbar--bordered': bordered }"
    :location="app ? 'top' : undefined"
    flat
    height="90"
  >
    <v-btn
      v-if="isDismissible"
      data-cy="toolbar_base_close_btn"
      class="close-btn"
      variant="text"
      :aria-label="$t('global.close')"
      :loading="loading"
      @click="emit('close')"
    >
      <v-icon size="24">custom:c_close</v-icon>
    </v-btn>
    <img v-else-if="srBrandingLogoUrl" class="logo" :src="srBrandingLogoUrl" alt="Logo" />
    <nuxt-img v-else class="logo" width="54" height="30" src="/img/logo-skribble.svg" alt="Skribble" />
    <component :is="titleComponent" data-cy="toolbar_base_title" class="toolbar__title">
      <template v-if="title">
        <span class="font-weight-bold">{{ title }}</span>
      </template>
      <slot v-else name="title" />
    </component>
    <template v-if="$slots.options">
      <v-spacer />
      <div class="toolbar__options">
        <slot name="options" />
      </div>
    </template>
  </component>
</template>

<style lang="scss" scoped>
.toolbar {
  --border: none;
  &--bordered {
    --border: 1px solid #{$c-border};
  }
  z-index: 1;
  background-color: $c-white;
  border-bottom: var(--border);
  &__title {
    font-size: 1rem;
    margin-left: 5 * $bw;
  }
  .logo {
    width: 42px;
    height: 100%;
    padding-inline: 24px;
    object-fit: contain;
    border-right: var(--border);
    box-sizing: content-box;
  }
  .close-btn {
    width: 90px;
    height: 100%;
    border-right: var(--border);
    margin: 0;
  }

  :deep(.v-toolbar__content) {
    padding: 0;
    color: rgb(var(--v-theme-on-surface-high-xqes));
  }
}
</style>
